// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__CLYHD","navbarLogo":"Navbar_navbarLogo__1ee5x","navbarPlaceholder":"Navbar_navbarPlaceholder__3npA9","userBtn":"Navbar_userBtn__C4CTs"};